import { render, staticRenderFns } from "./PropertyViewGlobal.vue?vue&type=template&id=174498a0&"
import script from "./PropertyViewGlobal.vue?vue&type=script&lang=js&"
export * from "./PropertyViewGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports